var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nut-tool-wrap" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.visiable
          ? _c("div", { staticClass: "nut-tool-tips" }, [
              _vm._v(_vm._s(_vm.content))
            ])
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }